export default {"src":"/_next/static/image/public/assets/icons/open-book.d7ace21006355b0343ad9e278f67312f.svg","height":24,"width":24};